import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-new-jersey-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./new-jersey-state-form.component.html",
  styleUrl: "./new-jersey-state-form.component.scss",
})
export class NewJerseyStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
